/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

export enum TSLeistungsart {
    UNTERNEHMERRECHNUNG = <any>'UNTERNEHMERRECHNUNG',
    OFFERTE = <any>'OFFERTE',
    MATERIAL = <any>'MATERIAL',
    HOLZ = <any>'HOLZ',
    PAUSCHAL = <any>'PAUSCHAL',
    MIETE = <any>'MIETE'
}

export function getLeistungsartValues(forSchaetzung: boolean): Array<TSLeistungsart> {
    let array = new Array<TSLeistungsart>();
    if (forSchaetzung) {
        array.push(TSLeistungsart.PAUSCHAL);
        array.push(TSLeistungsart.OFFERTE);
        array.push(TSLeistungsart.HOLZ);
    } else {
        array.push(TSLeistungsart.UNTERNEHMERRECHNUNG);
    }
    array.push(TSLeistungsart.MATERIAL);
    array.push(TSLeistungsart.MIETE);
    return array;
}

export function leistungsartPrefix(): string {
    return 'TSLeistugnsart_';
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSLeistungsart.ts